import { commaListSchema } from "@birdwatch/common";
import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { CheckoutLinksList } from "@/features/admin/checkout-links/list";
import {
  filterSearchFragment,
  withOperators,
} from "@/features/shared/filters-new";
import { maskSearchFragment } from "@/features/shared/route-masking";

const searchSchema = z.object({
  search: z.string().optional(),
  filters: z
    .object({
      // Boolean status (URL `status` → API `active`). Accepts the empty-shell
      // "" (chip added before a value is picked) plus the canonical
      // "true"/"false" the boolean widget writes.
      status: withOperators(
        z
          .union([z.literal("true"), z.literal("false"), z.literal("")])
          .optional(),
      ),
      planType: withOperators(commaListSchema),
    })
    .optional(),
  ...filterSearchFragment,
  sort: z.string().optional(),
  checkoutLinkId: z.string().optional(),
  tab: z.string().optional(),
  ...maskSearchFragment,
});

export const Route = createFileRoute("/admin/checkout-links/")({
  validateSearch: searchSchema,
  component: CheckoutLinksList,
});
